import api from '@/apiFetch/userOrder'

var actions = {
  // 获取各类型订单数目
  getOrderNumber({ commit }) {
    api.getOrderNumber()
      .then(data => {
        commit('setOrderNumber', data)
      })
      .catch(e => {
        this.$Message.error(e.errorMsg)
      })
  }
}
export default actions
